// extracted by mini-css-extract-plugin
module.exports = {"login_wrapper":"login_login_wrapper__XMT-K","submit_wrapper":"login_submit_wrapper__38B3N"};